export enum SportEventType {
  GAME_OF_THE_DAY = 'game_of_the_day',
  TOTO = 'toto',
}
